import React from 'react'
import { Route, IndexRoute } from 'react-router'
import { UserGoalsPageContainer } from '../UserGoalsPage'
import { GoalShowPageContainer } from '../GoalShowPage'
import { StandardLayout } from 'common/layouts/StandardLayout'

const Layout = ({ children }) => (
  <StandardLayout greyBg>
    {children}
  </StandardLayout>
)

const GoalEditPage = (props) => <GoalShowPageContainer {...props} editing />

export const routes = (
  <Route component={Layout}>
    <IndexRoute component={UserGoalsPageContainer} />
    <Route path='new' component={UserGoalsPageContainer} />
    <Route path=':goalId/edit' component={GoalEditPage} />
    <Route path=':goalId' component={GoalShowPageContainer} />
  </Route>
)
